import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../api";
import { useCurrentOrgao } from "../../hooks/useCurrentOrgao";
import { useDefaultSearchParams } from "../../hooks/useSearchParams";

type Props = {
  orgao_id?: string;
  search?: string;
};

export function useReschedulingDownloadPDF(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const currentOrgaoId = useCurrentOrgao();
  const defaultParams = useDefaultSearchParams();

  const searchParam = params?.search ?? defaultParams.search;
  const orgaoIdParam = params?.orgao_id ?? (currentOrgaoId ? currentOrgaoId.toString() : undefined);

  const queryParams: Record<string, string> = {};
  if (orgaoIdParam) {
    queryParams.orgao_id = orgaoIdParam;
  }
  if (searchParam) {
    queryParams.search = searchParam;
  }

  return useQuery({
    enabled: false,
    queryKey: ["download-arquivo", queryParams, currentOrgaoId],
    queryFn: async () => {
      const response = await apisiseci.get<Promise<Blob>>(
        "/cms/reagendamentos/relatorio/",
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: Object.keys(queryParams).length > 0 ? queryParams : undefined,
        }
      );
      return response.data;
    },
  });
}
